import { episodeOfCareAction } from 'src/redux/actions/constant';

const {
  EDIT_EPISODE_OF_CARE_FAILURE,
  EDIT_EPISODE_OF_CARE_SUCCESS,
  RESET_EDIT_EPISODE_OF_CARE
} = episodeOfCareAction;

const intitialstate: object = {
  isEdited: false,
  response: null,
};

export const editEpisodeOfCareReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case EDIT_EPISODE_OF_CARE_SUCCESS: {
      return {
        ...state,
        isEdited: true,
        response: action.payload,
      };
    }

    case EDIT_EPISODE_OF_CARE_FAILURE:
      return {
        ...state,
        isEdited: false,
        response: action.payload,
      };

    case RESET_EDIT_EPISODE_OF_CARE:
      return intitialstate;

    default:
      return state;
  }
};
